import MlQueries from "../MlQueries";

 
interface BankRiskScoreProps {
  tenantId: string;
  tenantServiceId: string;
  tenantServiceOptionId: string;
}

export const BankRiskScore = ({
  tenantId,
  tenantServiceId,
  tenantServiceOptionId,
}: BankRiskScoreProps) => {
  return (
    <MlQueries
      tenantId={tenantId}
      tenantServiceId={tenantServiceId}
      tenantServiceOptionId={tenantServiceOptionId}
      category="BANK_RISK_SCORE"
      title="Bank Risk Score"
    />
  );
};

export default BankRiskScore;
